import { Button, ButtonGroup } from 'Components/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { hasValue, valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions as amddActions } from '../../../../../Data/ReduxViewModels/AssignedValuesTests';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
interface iQueryInterface extends IWorksheetComponent {
  startDate: string;
  endDate: string;
}

let AsFindTestsButton: React.FC<iQueryInterface> = ({ createWorksheetSelector, startDate, endDate }) => {
  const dispatch = useDispatch();
  const CompactionMethod = useSelector(createWorksheetSelector!('ValueAssignment.CompactionMethod')) as string;
  const RestrictByMaterial = useSelector(
    pipe(createWorksheetSelector!('ValueAssignment.RestrictByMaterial'), valueOrDefault(false))
  ) as boolean;
  const RestrictBySource = useSelector(
    pipe(createWorksheetSelector!('ValueAssignment.RestrictBySource'), valueOrDefault(false))
  ) as boolean;
  const RestrictByProject = useSelector(
    pipe(createWorksheetSelector!('ValueAssignment.RestrictByProject'), valueOrDefault(false))
  ) as boolean;

  const ShowCompletedTests = useSelector(
    pipe(createWorksheetSelector!('ValueAssignment.RestrictByCompletedTests'), valueOrDefault(false))
  ) as boolean;

  const Material = useSelector((state) => state.worksheetEditor.syncModel.header.Sample?.Material?.Name) as string;
  const Source = useSelector((state) => state.worksheetEditor.syncModel.header.Sample?.MaterialSource?.Name) as string;
  const Project = useSelector((state) => state.worksheetEditor.syncModel.header.Project?.Code) as string;
  const querying = useSelector((state) => state.assignedMaximumDryDensityTests.status.querying);
  const queryIsInvalid = !hasValue(startDate) || !hasValue(endDate);
  return (
    <>
      <ButtonGroup>
        <Button
          disabled={queryIsInvalid}
          primary
          loading={querying}
          onClick={() =>
            dispatch(
              amddActions.getAvailableMdds({
                query: {
                  params: {
                    Project: RestrictByProject ? Project : undefined,
                    Source: RestrictBySource ? Source : undefined,
                    Material: RestrictByMaterial ? Material : undefined,
                    Completed: ShowCompletedTests,
                    DateSampledFrom: startDate,
                    DateSampledTo: endDate,
                    CompactionMethod: CompactionMethod,
                  },
                },
              })
            )
          }
        >
          Find Tests
        </Button>
      </ButtonGroup>
    </>
  );
};

AsFindTestsButton = withInjectedProps(AsFindTestsButton);

export { AsFindTestsButton };
export default AsFindTestsButton;
